import React from 'react'
import MarketInstrumentPage from './MarketInstrumentPage'

export default function Indices() {
  return (
    <MarketInstrumentPage
      activeMarket="Indices"
      heroSymbol="#"
      name="Indices"
      tagline="Trade major global indices, from Wall Street to Europe and Asia, in a single position."
      heroImageLabel="global stock index background"
      descriptionImageLabel="trader viewing index charts on laptop and mobile"
      description={{
        title: 'Trade The Market, Not Just One Stock',
        paragraphs: [
          'A stock index tracks the combined performance of a basket of companies within a country or sector — the S&P 500 tracks 500 large US companies, for example.',
          'Trading an index CFD with Xperia Capital gives you exposure to overall market direction in a single position, instead of picking individual stocks one at a time.',
        ],
      }}
      conditions={[
        { symbol: 'US500', desc: 'S&P 500 Index', minSpread: { STD: '0.6', ECN: '0.3', PRO: '0.2' }, avgSpread: { STD: '0.8', ECN: '0.4', PRO: '0.3' }, pipValue: '1.00', minMove: '0.1', contractValue: '$1 / pt' },
        { symbol: 'US100', desc: 'Nasdaq 100 Index', minSpread: { STD: '1.2', ECN: '0.8', PRO: '0.5' }, avgSpread: { STD: '1.5', ECN: '1.0', PRO: '0.7' }, pipValue: '1.00', minMove: '0.1', contractValue: '$1 / pt' },
        { symbol: 'UK100', desc: 'FTSE 100 Index', minSpread: { STD: '1.0', ECN: '0.6', PRO: '0.4' }, avgSpread: { STD: '1.3', ECN: '0.8', PRO: '0.5' }, pipValue: '1.00', minMove: '0.1', contractValue: '£1 / pt' },
        { symbol: 'JP225', desc: 'Nikkei 225 Index', minSpread: { STD: '6.0', ECN: '4.0', PRO: '3.0' }, avgSpread: { STD: '7.5', ECN: '5.0', PRO: '4.0' }, pipValue: '1.00', minMove: '1', contractValue: '¥100 / pt' },
      ]}
      whyTrade={[
        { icon: 'network', title: 'Whole-Market Exposure', desc: 'Trade the movement of an entire market or sector at once.' },
        { icon: 'target', title: 'Targeted Regions', desc: 'Choose indices tied to specific countries or economic themes.' },
        { icon: 'bolt', title: 'Efficient Execution', desc: 'Enter and exit positions quickly during active trading hours.' },
        { icon: 'barChart', title: 'Educated Decisions', desc: 'Index-level liquidity supports clearer entry and exit signals.' },
      ]}
      faqs={[
        { q: 'What are indices and how does trading them work?', a: 'Indices group together shares of many companies. Instead of buying individual shares, an index CFD lets you speculate on the direction of the whole basket.' },
        { q: 'How do you trade indices?', a: 'You open a CFD position on an index and it moves in line with the underlying basket of stocks — profiting if your directional view is correct.' },
        { q: 'What affects index prices?', a: 'Corporate earnings, interest rate decisions, macroeconomic data, and overall investor sentiment all move index prices.' },
        { q: 'Why trade indices instead of individual stocks?', a: 'Indices spread exposure across many companies at once, which can reduce the impact of any single company\'s news on your position.' },
      ]}
    />
  )
}
